// extracted by mini-css-extract-plugin
module.exports = {"slideWrap":"TravelDefaultSlider_slideWrap__zF49U","slideInner":"TravelDefaultSlider_slideInner__6WbrZ"};